// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2E24W","rightAdornment":"Header_rightAdornment__cymDb"};